import * as React from 'react';
import {useSelector} from 'react-redux';

import type {NutshellState} from '../../../../../store';
import {ReportProviderContext} from '../../../../reports/report-provider-context';

import {
    getCurrentReportChartIsLoading,
    getCurrentReportChartData,
    isChartTimedOut,
    isChartErrored,
} from './whatsapp-selectors';

type Props = {
    children: React.ReactNode;
};

export function WhatsAppReportProvider(props: Props) {
    const chartData = useSelector((state: NutshellState) => getCurrentReportChartData(state));
    const isLoading = useSelector((state: NutshellState) => getCurrentReportChartIsLoading(state));
    const isTimedOut = useSelector((state: NutshellState) => isChartTimedOut(state));
    const isErrored = useSelector((state: NutshellState) => isChartErrored(state));

    return (
        // @ts-expect-error
        <ReportProviderContext.Provider value={{chartData, isLoading, isTimedOut, isErrored}}>
            {props.children}
        </ReportProviderContext.Provider>
    );
}
